/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryModels } from "@/api/utils";

export function prepareQueryParams({
  paginationModel = {} as any,
  sortModel,
  filterModel,
}: QueryModels) {
  const query: Record<string, any> = { ...paginationModel };

  const sort = sortModel[0];
  if (sort?.field) query.orderBy = sort?.field;
  if (sort?.sort) query.orderDirection = sort?.sort.toUpperCase();

  filterModel.items.forEach((filter) => {
    const operator = filter.operator || "contains";

    if (operator === "doesNotContain" && filter.value !== undefined) {
      query[`${filter.field}.not`] = filter.value;
    } else if (operator === "isEmpty") {
      query[filter.field] = "";
    } else if (operator === "isNotEmpty") {
      query[`${filter.field}.not`] = "";
    } else if (filter.value !== undefined) {
      const existing = query[filter.field];
      if (existing !== undefined) {
        query[filter.field] = Array.isArray(existing)
          ? [...existing, filter.value]
          : [existing, filter.value];
      } else {
        query[filter.field] = filter.value;
      }
    }
  });

  return query;
}
